import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// import VuePlyr from "vue-plyr";
// import "vue-plyr/dist/vue-plyr.css";

import "@/assets/style/main.scss";
import vIntersection from "./directives/vIntersection";

const app = createApp(App);

app.use(store);
app.use(router);
// app.use(VuePlyr);
app.directive("intersection", vIntersection);

app.mount("#app");
